Article = {
	
	controller : false

	init : ->
		console.log "Article init"

		if not Config.isMobile()
			@stickyManager()

	stickyManager : ->


		# Sticky slider
		slider = $('.article-actu .actu--slider')
		articleHeight = $('.article-actu .actu--right').height()

		if slider.height() < articleHeight 

			# Sticky title on scroll
			scene = new ScrollMagic.Scene({triggerElement: slider[0], duration: articleHeight - slider.height(), triggerHook: 0.2, force3D:true})
				.setPin(slider[0])
				.addTo(App.controller)

		else
			setTimeout ->
				$('.article-actu .actu--right').height(slider.height())
			, 500

		# Sticky socials
		#if not Config.isMobile()
		#	scene = new ScrollMagic.Scene({triggerElement: $('.article-actu'), duration: articleHeight - $('.sharer').height() * 1.5, force3D:true})
		#		.setPin('.sharer')
		#		.addTo(App.controller)


	destroy : ->
		console.log "Article destroy"
}